/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { BaseProfile } from '~sq-server-commons/types/quality-profiles';
import { ProfileInheritanceDetails } from '~sq-server-commons/types/types';

export function isQualityProfileRecommendedForAI(profile: BaseProfile | ProfileInheritanceDetails) {
  return profile.isBuiltIn && profile.name === 'Sonar way';
}

export function getAICodeSettingsUrl(componentKey: string, qualifier: string) {
  return `/project/ai-project-settings?id=${componentKey}&qualifier=${qualifier}`;
}
